export default __webpack_public_path__ + "static/media/sellersCo_logo.578f6e77.png";